import styled from 'styled-components';

const DraggableWrapper = styled.div`
  cursor: grab;
  transition: opacity 0.1s ease-in-out;

  &[data-is-dragging='true'] {
    cursor: grabbing;
    opacity: 0.3;
  }

  &[data-is-disabled='true'] {
    cursor: not-allowed;
    pointer-events: none;
  }

  img {
    pointer-events: none;
  }
`;

export default DraggableWrapper;
